import { Role } from '@/enum/roles.enum';
import { Ability, AbilityBuilder, defineAbility } from '@casl/ability';

/**
 * 默认不具备任何操作权限
 */
const ability = defineAbility(() => {
});

export default ability;

export const updateAbility = (role: Role) => {
    const { can, rules } = new AbilityBuilder(Ability);
    if (role === Role.Admin) {
        can('manage', 'all');
    } else if (role.endsWith('Inspector')) {
        can('read', 'all');
    } else if (role.startsWith('Cmp')) {
        // 平台用户
        can('create', 'User');
        can('update', 'User');
        // 协议
        can('read', 'Proto');
        // 企业
        can('update', 'Company');
        // 项目
        can('create', 'Project');
        can('update', 'Project');
        can('read', 'Project');
        // 2024-10-17 放开新增采集终端和传感器功能
        // 终端
        can('create', 'Terminal')
        can('read', 'Terminal')
        can('update', 'Terminal')
        // 传感器
        can('create', 'Sensor')
        can('read', 'Sensor')
        can('update', 'Sendor')

    } else if (role.startsWith('Proj')) {
        // 2024-10-17 放开新增采集终端和传感器功能
        // 终端
        can('create', 'Terminal')
        can('update', 'Terminal')
        // 传感器
        can('create', 'Sensor')
        can('update', 'Sensor')
    }
    ability.update(rules);
}